export default {
  currentSession: {
    id: '',
    role: '',
    login: '',
    scopes: null
  },
  currentUser: {
    id: '',
    role: '',
    login: '',    
    email: '',
    name: '',    
    isPasswordSet: null,
    readOnly: null
  },
  currentPerson: null, // текущее физ лицо 
  ownerPerson: null    // физ лицо владельца кабинета
}
